import api from '@/apis'
import { API_PREFIX } from '@/constants'
import type { DeleteOrderResponse } from '@/payment/types'

/**
 * 밀봉비닐 주문 신청 취소 — DELETE /order/api/v2/product-orders/{orderId}.
 *
 * 422 에러:
 *  - E422203: 수거크루 이동중 취소 불가
 *  - E422207: 22:00 ~ 22:10 시간대 취소 불가
 *
 * ⚠️ TODO(backend): DELETE 후 환불 자동 처리 여부 확인 (단건결제 시).
 */
export const apiDeleteOrder = async (orderId: number): Promise<DeleteOrderResponse> => {
  return api.delete(`${API_PREFIX.ORDER}/product-orders/${orderId}`)
}
